import { Modal, Button } from 'rsuite';
import styles from './ModalRemoveSegment.module.scss';
import { useSetupISACustomSegmentsStore } from '../../SetupISACustomSegments.store';
import { useRemoveCustomSegment } from '../../hooks/useRemoveCustomSegment';

type ModalRemoveSegmentProps = {
  show: boolean;
};

export const ModalRemoveSegment = ({ show }: ModalRemoveSegmentProps) => {
  const { setSetupISACustomSegmentsState, selectedSegmentID } = useSetupISACustomSegmentsStore();
  const { handleRemoveSegmentMutation } = useRemoveCustomSegment();

  const handleClose = () => {
    setSetupISACustomSegmentsState('openModalRemoveSegment', false);
    setSetupISACustomSegmentsState('selectedSegmentID', null);
  };

  const handleRemoveSegment = (id: number) => {
    if (!id) return;

    handleRemoveSegmentMutation(id);
  };

  return (
    <Modal backdrop show={show} className={styles['modal-remove-segment']} onHide={handleClose}>
      <Modal.Header closeButton className={styles.header} onHide={handleClose}>
        <Modal.Title className={styles.title}>Excluir segmento</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        <span>
          Ao deletar este segmento, todos os filtros vinculados a ele serão removidos do Infopanel. <b>Tem certeza que deseja excluir este segmento?</b>
        </span>
      </Modal.Body>
      <Modal.Footer className={styles.footer}>
        <Button className={styles['cancel-btn']} onClick={handleClose} appearance="ghost" color="blue">
          Cancelar
        </Button>
        <Button
          className={styles['confirm-btn']}
          onClick={() => handleRemoveSegment(selectedSegmentID)}
          appearance="primary"
          id="modal-edit-segments-confirm-btn"
        >
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
